import template from './account-billing.pug';
import controller from './account-billing.controller';

export const AccountBillingComponent = {
  template,
  controller,
  controllerAs: '$ctrl'
};

export default AccountBillingComponent;
